import { useCallback, useState } from 'react';

import { adminLocalizationKeys } from '@/api';
import { ConstructorApi } from '@/features/constructorProducts/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useProductLink = () => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async (product) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.addProductLink(product);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Created new link');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleUpdate = useCallback(async (link) => {
    try {
      setIsUpdating(true);
      const result = await ConstructorApi.changeProductLink(link);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (productLinkId) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteProductLink(productLinkId);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Deleted');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  };
};
